import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from "react";
const SelectionContext = createContext(undefined);
export const SelectionProvider = ({ children }) => {
    const [selectedSlides, setSelectedSlides] = useState(new Set());
    const [selectedSections, setSelectedSections] = useState(new Set());
    const [isSelecting, setIsSelecting] = useState(false);
    const [selectionStart, setSelectionStart] = useState(null);
    const [selectionEnd, setSelectionEnd] = useState(null);
    const [editingSelection, setEditingSelection] = useState(false);
    const [editSelectionPrompt, setEditSelectionPrompt] = useState("");
    const [processingEditSelection, setProcessingEditSelection] = useState(false);
    const clearSelection = useCallback(() => {
        setSelectedSlides(new Set());
        setSelectedSections(new Set());
        setEditingSelection(false);
        setEditSelectionPrompt("");
    }, []);
    const toggleSlideSelection = useCallback((slideId, ctrlKey) => {
        setSelectedSlides(prev => {
            const newSet = new Set(prev);
            if (ctrlKey) {
                if (newSet.has(slideId)) {
                    newSet.delete(slideId);
                }
                else {
                    newSet.add(slideId);
                }
            }
            else {
                newSet.clear();
                newSet.add(slideId);
            }
            return newSet;
        });
    }, []);
    const value = {
        selectedSlides,
        selectedSections,
        isSelecting,
        selectionStart,
        selectionEnd,
        editingSelection,
        editSelectionPrompt,
        processingEditSelection,
        setSelectedSlides,
        setSelectedSections,
        setIsSelecting,
        setSelectionStart,
        setSelectionEnd,
        setEditingSelection,
        setEditSelectionPrompt,
        setProcessingEditSelection,
        clearSelection,
        toggleSlideSelection,
    };
    return _jsx(SelectionContext.Provider, { value: value, children: children });
};
export const useSelection = () => {
    const context = useContext(SelectionContext);
    if (!context) {
        throw new Error("useSelection must be used within a SelectionProvider");
    }
    return context;
};
